import { render, staticRenderFns } from "./EntrustFlow.vue?vue&type=template&id=5fac2dfc&scoped=true"
import script from "./EntrustFlow.vue?vue&type=script&lang=js"
export * from "./EntrustFlow.vue?vue&type=script&lang=js"
import style0 from "./EntrustFlow.vue?vue&type=style&index=0&id=5fac2dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fac2dfc",
  null
  
)

export default component.exports